import angular from 'angular';
import moment from 'moment';

/**
 * @typedef {Object} AlarmLogRecord
 * @property {number} idAlarm
 * @property {number} idSite
 * @property {number} instance
 * @property {string} type
 * @property {string} description
 * @property {number} started - Unix seconds
 * @property {number|null} cleared - Unix seconds
 * @property {number} idDataAttribute
 */

/**
 * @typedef {AlarmLogRecord} AlarmsOverviewRecord
 * @property {number} isActive - 0 or 1
 * @property {string} device
 * @property {string} customName
 * @property {string|null} nameEnum
 *
 * @property {object|null} installation
 */

angular.module('vrm.components').directive('vrmAlarms', vrmAlarms);

/* @ngInject */
function vrmAlarms() {
    return {
        scope: {},
        restrict: 'E',
        template: require('@/angular/modules/vrm-components/alarms/alarms.template.html'),
        controller,
    };
}

/* @ngInject */
function controller(
    $scope,
    $state,
    $filter,
    $q,
    ApiService,
    InstallationsService,
    AlarmsCacheService,
    $timeout,
) {
    $scope.loading = true;
    /** @type {AlarmsOverviewRecord[]} */
    $scope.alarms = AlarmsCacheService.cachedAlarms;
    $scope.installations = [];

    function loadInstallations() {
        return InstallationsService.loading.then(() => InstallationsService.installations);
    }

    $q.all([
        AlarmsCacheService.fetchAlarms(),
        loadInstallations(),
    ]).then(([alarms, installations]) => {
        $scope.installations = installations;
        $scope.alarms = alarms;
        $scope.alarms.forEach(alarm => {
            alarm.installation = $scope.installations.find(site => site.idSite === alarm.idSite);
            alarm.rowHovered = false;
            alarm.advancedHovered = false;
        });
        $scope.loading = false;
    });

    /**
     * @param {AlarmsOverviewRecord} alarm
     */
    $scope.getTrigger = alarm => {
        const type = alarm.type;
        switch (type) {
            case 'float':
            case 'enum':
                return 'Alarm rule';
            case 'device missing':
            case 'alarm monitor':
                return 'Automatic monitoring';
            default:
                return type.charAt(0).toUpperCase() + type.slice(1);
        }
    };

    /**
     * @param {AlarmsOverviewRecord} alarm
     */
    $scope.gotoInstallation = alarm => {
        $state.go('base.installation.alarmlogs', {id: alarm.idSite});
    };

    /**
     * @param {AlarmsOverviewRecord} alarm
     */
    $scope.gotoAdvanced = alarm => {
        if (!alarm.started) return;
        const start = moment.unix(alarm.started).startOf('day').valueOf();
        const end = moment.unix(alarm.started).endOf('day').valueOf();
        $state.go('base.installation.advanced', {id: alarm.idSite, start: start, end: end});
    };

    const tooltipDelay = 100;
    $scope.onRowEnter = alarm => {
        alarm.rowHoverDelay = $timeout(() => {
            alarm.rowHovered = true;
        }, tooltipDelay);
    };
    $scope.onRowLeave = alarm => {
        alarm.rowHovered = false;
        if (alarm.rowHoverDelay) {
            $timeout.cancel(alarm.rowHoverDelay);
            alarm.rowHoverDelay = null;
        }
    };
    $scope.onAdvancedEnter = alarm => {
        alarm.advancedHoverDelay = $timeout(() => {
            alarm.advancedHovered = true;
        }, tooltipDelay);
    };
    $scope.onAdvancedLeave = alarm => {
        alarm.advancedHovered = false;
        if (alarm.advancedHoverDelay) {
            $timeout.cancel(alarm.advancedHoverDelay);
            alarm.advancedHoverDelay = null;
            alarm.advancedHoverDelay = null;
        }
    };
}
